import { ErrorLayout } from "@/layouts/error-layout";
export default function Custom404() {
  return <>
            <ErrorLayout title={'Page Not Found'} errorCode={404} data-sentry-element="ErrorLayout" data-sentry-source-file="404.tsx" />
        </>;
}